<template>
  <div>
    <header id="header" class="header">
      <div class="main-header">
        <div class="inner">
          <div class="flexstart">
            <div class="rslogo"><img src="static/images/icon/header/logo.png"></div>
            <div class="header-contentname lbold font18">{{ contentName }}</div>
          </div><!-- flexstart -->
        </div><!-- inner -->
      </div><!-- main-header -->
    </header><!-- header -->
  </div>
</template>

<script>
export default {
  name: 'simpleHeader',
  props: {
    contentName: String,
  },
};
</script>

<style lang="scss">
@import 'src/assets/style/header';
</style>



// WEBPACK FOOTER //
// Header.vue?14f86df7